const STORE_IMAGE_PREFIXES = [
  "/images/",
  "images/",
  "/product/images/store/",
  "product/images/store/",
  "/product/images/",
  "product/images/",
];

const extractFileName = (value) => {
  const normalized = String(value || "").trim().replace(/\\/g, "/");
  if (!normalized) return "";

  const withoutQuery = normalized.split("?")[0].split("#")[0];
  const parts = withoutQuery.split("/").filter(Boolean);
  return parts[parts.length - 1] || "";
};

export const toPublicImagePath = (value) => {
  const normalized = String(value || "").trim().replace(/\\/g, "/");
  if (!normalized) return "";

  if (/^https?:\/\//i.test(normalized) || /^data:/i.test(normalized)) {
    return normalized;
  }

  const fileName = extractFileName(normalized);
  if (!fileName) return "";

  return `/images/${fileName}`;
};

export const normalizeStoreImagePath = (value) => {
  const normalized = String(value || "").trim().replace(/\\/g, "/");
  if (!normalized) return "";

  if (/^https?:\/\//i.test(normalized) || /^data:/i.test(normalized)) {
    return normalized;
  }

  if (STORE_IMAGE_PREFIXES.some((prefix) => normalized.startsWith(prefix))) {
    return toPublicImagePath(normalized);
  }

  if (normalized.startsWith("/")) {
    return normalized;
  }

  return toPublicImagePath(normalized);
};

export const normalizeStoreImageList = (values) =>
  Array.from(
    new Set(
      (Array.isArray(values) ? values : [])
        .map((value) => normalizeStoreImagePath(value))
        .filter(Boolean)
    )
  );
